"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
require("rxjs/add/operator/takeUntil");
var PopupButtonConfigComponent = /** @class */ (function () {
    function PopupButtonConfigComponent() {
        this.configsChanged = new core_1.EventEmitter();
    }
    PopupButtonConfigComponent.prototype.onSearchKeywordSelect = function (searchKeywords, buttonConfig) {
        buttonConfig.searchKeywords = searchKeywords;
        this.configsChanged.emit(true);
    };
    PopupButtonConfigComponent.prototype.onHasCreateButtonRadioSelect = function (hasCreateButton, buttonConfig) {
        buttonConfig.hasCreateButton = hasCreateButton.value;
        this.configsChanged.emit(true);
    };
    PopupButtonConfigComponent.prototype.onFilterFieldsSelect = function (filterFields, buttonConfig) {
        buttonConfig.filterFields = filterFields;
        this.configsChanged.emit(true);
    };
    PopupButtonConfigComponent.prototype.onColumnSelect = function (columns, buttonConfig) {
        if (columns.length > 6) {
            columns.pop();
        }
        buttonConfig.columns = columns;
        this.configsChanged.emit(true);
    };
    PopupButtonConfigComponent.prototype.onSubFormSelect = function (subFormId, buttonConfig) {
        buttonConfig.subFormId = subFormId;
        this.configsChanged.emit(true);
    };
    PopupButtonConfigComponent.prototype.onNameFieldSelect = function (metaFields, buttonConfig) {
        if (metaFields.length > 2) {
            metaFields.pop();
        }
        buttonConfig.selectedItemFields = metaFields;
        this.configsChanged.emit(true);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], PopupButtonConfigComponent.prototype, "buttonConfigs", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], PopupButtonConfigComponent.prototype, "categoryName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], PopupButtonConfigComponent.prototype, "mainEntityMetaFields", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], PopupButtonConfigComponent.prototype, "subEntityMetaFields", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], PopupButtonConfigComponent.prototype, "textFields", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], PopupButtonConfigComponent.prototype, "filterFields", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], PopupButtonConfigComponent.prototype, "columnFields", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], PopupButtonConfigComponent.prototype, "categoryForms", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], PopupButtonConfigComponent.prototype, "instanceFieldName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], PopupButtonConfigComponent.prototype, "imageFieldName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], PopupButtonConfigComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], PopupButtonConfigComponent.prototype, "useSameSearchSettings", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], PopupButtonConfigComponent.prototype, "configsChanged", void 0);
    PopupButtonConfigComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-popup-button-config',
            styles: [require('./popup-button-config.component.css')],
            template: require('./popup-button-config.component.html')
        })
    ], PopupButtonConfigComponent);
    return PopupButtonConfigComponent;
}());
exports.PopupButtonConfigComponent = PopupButtonConfigComponent;
//# sourceMappingURL=popup-button-config.component.js.map